import { render, staticRenderFns } from "./JustifyRtaModal.vue?vue&type=template&id=270dcfe9&"
import script from "./JustifyRtaModal.vue?vue&type=script&lang=js&"
export * from "./JustifyRtaModal.vue?vue&type=script&lang=js&"
import style0 from "./JustifyRtaModal.vue?vue&type=style&index=0&id=270dcfe9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports